import { PaginatedResponse } from '@/calendesk/models/DTO/Response/Interface/PaginatedResponse'
import { Expose, Type } from 'class-transformer'
import PaymentTransaction from '@/calendesk/models/DTO/Response/PaymentTransaction'

export default class BookingPaymentTransactionResponse extends PaginatedResponse {
  @Expose()
  @Type(() => PaymentTransaction)
  public data!: Array<PaymentTransaction>
}
